// src/services/terreniAPI.js
import apiClient from './apiClient';

const terreniAPI = {
  getAllTerreni: (params = {}) => {
    // Construct query parameters
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.company_id) queryParams.append('company_id', params.company_id);
    
    const queryString = queryParams.toString();
    return apiClient.get(`/terreni/index${queryString ? '?' + queryString : ''}?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`)
  },
  getTerreni: (terreniId) => apiClient.get(`/terreni/show/${terreniId}?company_id=${localStorage.getItem('company_id')}`),
  createTerreni: (terreniData) => apiClient.post(`/terreni/store?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`, terreniData),
  updateTerreni: (terreniId, terreniData) => apiClient.post(`/terreni/update/${terreniId}?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`, terreniData),
  deleteTerreni: (terreniId) => apiClient.delete(`/terreni/delete/${terreniId}?company_id=${localStorage.getItem('company_id')}${localStorage.getItem('cantine_id') ? `&cantina_id=${localStorage.getItem('cantine_id')}` : ''}`),
  duplicateTerreni: (terreniId) => apiClient.post(`/terreni/duplicate/${terreniId}?company_id=${localStorage.getItem('company_id')}`),
  
  // Enum getters
  getEsposizione: () => apiClient.get(`/terreni/get-esposizione?company_id=${localStorage.getItem('company_id')}`),
  getTipoSuolo: () => apiClient.get(`/terreni/get-tipo-suolo?company_id=${localStorage.getItem('company_id')}`),
  getSistemaColtivazione: () => apiClient.get(`/terreni/get-sistema-coltivazione?company_id=${localStorage.getItem('company_id')}`),

  getCultura: () => apiClient.get(`/terreni/get-cultura?company_id=${localStorage.getItem('company_id')}`),
  getUliveto: () => apiClient.get(`/terreni/get-uliveto?company_id=${localStorage.getItem('company_id')}`),
  getVarieta: () => apiClient.get(`/terreni/get-varieta?company_id=${localStorage.getItem('company_id')}`),
};

export default terreniAPI;